import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikHelpers } from 'formik';
import { object, string } from 'yup';
import { StudentFormValues } from 'src/models/Student.mode';
import Student from '../Layouts/StudentForm';
import { useAddStudentMutation } from 'src/services/StudentService';
import { showToast } from 'src/utils/showToaster';

type Props = {
  onClose: () => void;
};

const AddStudentWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: StudentFormValues = {
    name: '',
    mobile: '',
  };

  // Validation Schema
  const validationSchema = object().shape({
    name: string().required('Please enter Student name'),
    mobile: string().required('Please enter mobile number').min(10).max(10),
  });

  const [addStudent] = useAddStudentMutation()

  // Handle Submit
  const handleSubmit = (
    values: StudentFormValues,
    { setSubmitting, resetForm }: FormikHelpers<StudentFormValues>
  ) => {
    addStudent(values).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm()
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <Student formikProps={formikProps} onClose={onClose}  formType='ADD'/>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddStudentWrapper;